// extracted by mini-css-extract-plugin
export default {"wrapper":"NavBar_wrapper__LJ-IN","link":"NavBar_link__kzh1w"};